<template>
  <div class="mall-h5">
    <!-- 顶部导航 -->
    <div class="mh5-topbar">
      <van-icon name="arrow-left" @click="$router.back()" />
      <span>商品详情</span>
      <div class="mh5-topbar__actions">
        <van-icon name="share-o" @click="onShare" />
      </div>
    </div>

    <div v-if="product" class="mh5-detail">
      <!-- 主图/详情图轮播 -->
      <swiper :options="swiperOption" class="mh5-banner" v-if="images.length">
        <swiper-slide v-for="(img, i) in images" :key="i">
          <img :src="img" class="mh5-banner__img" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination" />
      </swiper>
      <div v-else class="mh5-banner mh5-banner--empty">
        <van-icon name="photo-o" />
        <span>暂无图片</span>
      </div>

      <!-- 价格与名称 -->
      <div class="mh5-info">
        <div class="mh5-info__price">
          <template v-if="hasDiscount(product)">
            <span class="mh5-info__price--tag">特惠</span>
            <span class="mh5-info__price--sym">¥</span>
            <span class="mh5-info__price--num">{{ product.discountPrice }}</span>
            <span class="mh5-info__price--orig">¥{{ product.retailPrice }}</span>
          </template>
          <template v-else>
            <span class="mh5-info__price--sym">¥</span>
            <span class="mh5-info__price--num">{{ product.retailPrice }}</span>
          </template>
        </div>
        <div class="mh5-info__name">{{ product.productName }}</div>
        <div class="mh5-info__meta">
          <span v-if="product.spec">{{ product.spec }}</span>
          <span v-if="product.spec && product.unit" class="mh5-info__meta-divider">·</span>
          <span v-if="product.unit">{{ product.unit }}</span>
          <span class="mh5-info__meta-divider" v-if="product.stock">·</span>
<!--          <span v-if="product.stock" class="mh5-info__stock">库存 {{ product.stock }}{{ product.unit }}</span>-->
        </div>
      </div>

      <!-- 商品属性 -->
      <div class="mh5-attrs">
        <div class="mh5-attrs__title">商品参数</div>
        <div class="mh5-attrs__grid">
          <div class="mh5-attr" v-if="product.brand">
            <span class="mh5-attr__label">品牌</span>
            <span class="mh5-attr__value">{{ product.brand }}</span>
          </div>
          <div class="mh5-attr" v-if="product.category">
            <span class="mh5-attr__label">分类</span>
            <span class="mh5-attr__value">{{ product.category }}</span>
          </div>
          <div class="mh5-attr" v-if="product.barcode">
            <span class="mh5-attr__label">条形码</span>
            <span class="mh5-attr__value">{{ product.barcode }}</span>
          </div>
          <div class="mh5-attr" v-if="product.packQty">
            <span class="mh5-attr__label">包装数量</span>
            <span class="mh5-attr__value">{{ product.packQty }}</span>
          </div>
          <div class="mh5-attr" v-if="product.productSize">
            <span class="mh5-attr__label">产品尺寸</span>
            <span class="mh5-attr__value">{{ product.productSize }}</span>
          </div>
          <div class="mh5-attr" v-if="product.grossWeight">
            <span class="mh5-attr__label">产品毛重</span>
            <span class="mh5-attr__value">{{ product.grossWeight }}kg</span>
          </div>
          <div class="mh5-attr" v-if="product.boxSize">
            <span class="mh5-attr__label">箱尺寸</span>
            <span class="mh5-attr__value">{{ product.boxSize }}</span>
          </div>
          <div class="mh5-attr" v-if="product.boxWeight">
            <span class="mh5-attr__label">箱毛重</span>
            <span class="mh5-attr__value">{{ product.boxWeight }}kg</span>
          </div>
        </div>
      </div>

      <!-- 商品说明 -->
      <div class="mh5-remark" v-if="product.remark">
        <div class="mh5-remark__title">商品说明</div>
        <div class="mh5-remark__text">{{ product.remark }}</div>
      </div>
    </div>

    <!-- 底部安全区 -->
    <div class="mh5-safe-bottom" />

    <!-- 底部操作栏 -->
    <div class="mh5-action" v-if="product">
      <div class="mh5-qty">
        <span class="mh5-qty__label">数量</span>
        <div class="mh5-stepper">
          <div class="mh5-stepper__btn" :class="{ disabled: quantity <= 1 }" @click="changeQty(-1)">-</div>
          <div class="mh5-stepper__num">{{ quantity }}</div>
          <div class="mh5-stepper__btn" :class="{ disabled: quantity >= product.stock }" @click="changeQty(1)">+</div>
        </div>
      </div>
      <div class="mh5-action__btns">
        <div class="mh5-btn mh5-btn--cart" @click="onAddCart">加入购物车</div>
        <div class="mh5-btn mh5-btn--buy" @click="onBuyNow">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mallH5ProductDetail } from '@/api/mall'
import { addToCart } from './cartStore'
import { restoreMallCtx, withCtx } from './mallCtx'

export default {
  name: 'MallH5Detail',
  data() {
    return {
      product: null,
      quantity: 1,
      swiperOption: {
        pagination: { el: '.swiper-pagination', bulletClass: 'swiper-pagination-bullet', bulletActiveClass: 'swiper-pagination-bullet-active' },
        loop: false,
        autoplay: false
      }
    }
  },
  computed: {
    images() {
      const imgs = []
      if (this.product && this.product.mainImg) imgs.push(this.product.mainImg)
      if (this.product && this.product.detailImgs) {
        try {
          const arr = JSON.parse(this.product.detailImgs)
          if (Array.isArray(arr)) imgs.push(...arr)
        } catch (e) { /* ignore */ }
      }
      return imgs
    }
  },
  created() {
    restoreMallCtx(this.$route)
    this.fetchDetail()
  },
  methods: {
    hasDiscount(p) {
      return p && p.discountPrice != null && Number(p.discountPrice) < Number(p.retailPrice)
    },
    sellPrice(p) {
      return this.hasDiscount(p) ? p.discountPrice : p.retailPrice
    },
    async fetchDetail() {
      const id = this.$route.query.id
      const res = await mallH5ProductDetail(id)
      this.product = res.data
    },
    changeQty(delta) {
      const v = this.quantity + delta
      if (v < 1) return
      if (this.product && v > this.product.stock) {
        this.$toast('库存不足')
        return
      }
      this.quantity = v
    },
    onAddCart() {
      addToCart(this.product, this.quantity)
      this.$toast('已加入购物车')
    },
    onBuyNow() {
      const item = {
        productId: this.product.id,
        productName: this.product.productName,
        mainImg: this.product.mainImg,
        spec: this.product.spec,
        unit: this.product.unit,
        price: this.sellPrice(this.product),
        quantity: this.quantity
      }
      sessionStorage.setItem('mall_buy_now', JSON.stringify([item]))
      this.$router.push({ path: '/h5/mall/checkout', query: withCtx({ mode: 'buynow' }) })
    },
    onShare() {
      this.$toast('点击右上角分享给好友')
    }
  }
}
</script>

<style scoped>
/* ===== 全局基调 ===== */
.mall-h5 {
  min-height: 100vh;
  background: #F8F4F0;
  padding-bottom: 80px;
  -webkit-font-smoothing: antialiased;
}

/* ===== 顶部导航 ===== */
.mh5-topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  background: #fff;
  font-size: 17px;
  font-weight: 600;
  color: #3C3C3C;
  padding: 0 14px;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}
.mh5-topbar i {
  position: absolute;
  left: 14px;
  font-size: 20px;
  color: #666;
}
.mh5-topbar__actions {
  position: absolute;
  right: 14px;
  display: flex;
  gap: 16px;
}
.mh5-topbar__actions i {
  position: static;
  font-size: 20px;
  color: #666;
}

/* ===== 轮播图 ===== */
.mh5-banner {
  width: 100%;
  height: 375px;
  background: #fff;
}
.mh5-banner__img {
  width: 100%;
  height: 375px;
  object-fit: contain;
  background: #FAF8F6;
}
.mh5-banner--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #C4BDB3;
  gap: 8px;
}
.mh5-banner--empty i { font-size: 48px; }
.mh5-banner--empty span { font-size: 14px; }

/* ===== 价格信息 ===== */
.mh5-info {
  background: #fff;
  padding: 16px;
  margin-top: 0;
}
.mh5-info__price {
  color: #C0392B;
  line-height: 1;
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.mh5-info__price--tag {
  align-self: center;
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.mh5-info__price--sym {
  font-size: 16px;
  font-weight: 600;
}
.mh5-info__price--num {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -1px;
}
.mh5-info__price--orig {
  font-size: 14px;
  color: #B0A89E;
  text-decoration: line-through;
  font-weight: 400;
}
.mh5-info__name {
  font-size: 18px;
  color: #3C3C3C;
  margin-top: 10px;
  line-height: 1.5;
  font-weight: 600;
}
.mh5-info__meta {
  font-size: 13px;
  color: #B0A89E;
  margin-top: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.mh5-info__meta-divider {
  margin: 0 6px;
  color: #D4CFC8;
}
.mh5-info__stock {
  color: #C9A96E;
}

/* ===== 商品参数 ===== */
.mh5-attrs {
  background: #fff;
  margin-top: 12px;
  padding: 16px;
}
.mh5-attrs__title {
  font-size: 16px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F0ECE6;
}
.mh5-attrs__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px 0;
}
.mh5-attr {
  display: flex;
  padding: 8px 0;
  font-size: 13px;
}
.mh5-attr__label {
  color: #B0A89E;
  width: 64px;
  flex-shrink: 0;
}
.mh5-attr__value {
  color: #3C3C3C;
  flex: 1;
}

/* ===== 商品说明 ===== */
.mh5-remark {
  background: #fff;
  margin-top: 12px;
  padding: 16px;
}
.mh5-remark__title {
  font-size: 16px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F0ECE6;
}
.mh5-remark__text {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  white-space: pre-wrap;
}

/* ===== 底部安全区 ===== */
.mh5-safe-bottom { height: 16px; }

/* ===== 底部操作栏 ===== */
.mh5-action {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 64px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 14px;
  box-shadow: 0 -2px 12px rgba(0,0,0,0.06);
  z-index: 20;
  padding-bottom: env(safe-area-inset-bottom);
}
.mh5-qty {
  display: flex;
  align-items: center;
  margin-right: 16px;
}
.mh5-qty__label {
  font-size: 13px;
  color: #999;
  margin-right: 10px;
}
.mh5-stepper {
  display: flex;
  align-items: center;
  border: 1px solid #E8E3DA;
  border-radius: 6px;
  overflow: hidden;
}
.mh5-stepper__btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  background: #FAF8F6;
  cursor: pointer;
  transition: background 0.15s;
}
.mh5-stepper__btn:active { background: #F0ECE6; }
.mh5-stepper__btn.disabled { color: #D4CFC8; }
.mh5-stepper__num {
  width: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  border-left: 1px solid #E8E3DA;
  border-right: 1px solid #E8E3DA;
  height: 30px;
  line-height: 30px;
  color: #3C3C3C;
}
.mh5-action__btns {
  display: flex;
  flex: 1;
  gap: 10px;
}
.mh5-btn {
  flex: 1;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 21px;
  font-size: 15px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
  letter-spacing: 0.5px;
}
.mh5-btn--cart {
  background: linear-gradient(135deg, #C9A96E, #B8944E);
  box-shadow: 0 4px 12px rgba(201,169,110,0.3);
}
.mh5-btn--buy {
  background: linear-gradient(135deg, #C0392B, #A3312A);
  box-shadow: 0 4px 12px rgba(192,57,43,0.3);
}
.mh5-btn:active { opacity: 0.9; }
</style>
